// @flow

import React from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';
import { useLanguage } from '../i18n';

const languages = [
    { code: 'en', label: 'English' },
    { code: 'bg', label: 'Български' },
    { code: 'ro', label: 'Română' },
    { code: 'el', label: 'Ελληνικά' },
];

const LanguageSelector = (): React$Node => {
    const { language, setLanguage } = useLanguage();

    return (
        <FormControl size="small" sx={{ minWidth: 120 }}>
            <Select
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                displayEmpty
            >
                {languages.map((lang) => (
                    <MenuItem key={lang.code} value={lang.code}>
                        {lang.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default LanguageSelector;
